import {env} from "@/lib/env.ts";
import {BrandInfo} from "@/lib/queries/accounts.ts";
import {parseOrigin} from "@/lib/utils/urlUtils.ts";

export const URL_ORIGINAL_WEBSITE = env.VITE_URL_ORIGINAL_WEBSITE;

export const URL_UPSTART_AI = parseOrigin(env.VITE_URL_UPSTART_AI);

export const MARKDOWN_GUIDE_URL = "https://www.markdownguide.org/cheat-sheet/";

export const URL_TERMS_AND_CONDITIONS = "https://uptime.com/terms-and-conditions";
export const URL_PRIVACY_POLICY = "https://uptime.com/privacy-policy";

export const PRIVATE_LOCATION_SUPPORT_URL =
  "https://support.uptime.com/hc/en-us/articles/360012622239-Getting-Started-with-Private-Location-Monitoring";

export const PRIVATE_LOCATION_PHOTON_INSTALL_URL = "https://uptime.com/blog/using-private-locations-with-photonos-5-0";

export const STATUS_PAGE_COMPONENTS_AND_METRICS_URL =
  "https://support.uptime.com/hc/en-us/articles/29661861374748-Status-Page-Components-and-System-Metrics";

export const STATUS_PAGE_OVERVIEW_URL =
  "https://support.uptime.com/hc/en-us/articles/27107749059740-Overview-of-Status-Pages";

export const STATUS_PAGE_COMPONENT_URL = `${STATUS_PAGE_COMPONENTS_AND_METRICS_URL}#h_01M08X4VR7GHC05CYP664FAX58`;

export const STATUS_PAGE_SYSTEM_METRIC_URL = `${STATUS_PAGE_COMPONENTS_AND_METRICS_URL}#h_01M08X4VSAD9BJP19Q84ZFHMFT`;

export enum PageLink {
  API_DOCS = "api/v1/docs/",
  BROWSABLE_API = "api/v1/",
  PUBLIC_PROBE_SERVERS_CSV = "monitoring/servers.csv",
}

export const getLink = (brandInfo: BrandInfo, p: PageLink) => {
  return `${brandInfo.siteURL}/${p}`;
};
